import { combineReducers } from "redux";
import theme from "./theme/themeSlice";
import auth from "./auth";
import base from "./base";
import content from "./content";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    base,
    content,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
